// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1f5q1","containerItemsCenter":"Skeleton_containerItemsCenter__3OHEb"};